import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "new-list-flag"
}

import { ref, reactive, computed, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import Modal from '@/hooks/modalType'
import ImportBtn from '@/components/ImportBtn'
import ClueAssign from '../components/ClueAssign.vue'
import BecomeValid from './components/BecomeValid.vue'
import BecomeInvalid from './components/BecomeInvalid.vue'
import ClueMarge from './components/ClueMarge.vue'
import CustomerArea from '@/components/CustomerArea'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { listByParamCodes, adminArea } from '@/api/common'
import { customerUnfollowDayTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { clueStatusEnum, clueTypeEnum } from '../dataConfig'
import { salesClueList, salesClueRefund, salesClueDelete, salesClueDetail } from '@/api/overseasSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { SalesClueParams, SalesClueListItem } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash-es'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'

const __default__ = { name: 'DcCosOFbuSalesClue' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

// 线索类型枚举列表
const clueTypeEnumComputed = computed(() => clueTypeEnum.filter((item) => item.value !== 0))
const statusEnum = computed(() =>
  clueStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
)
// 业务参数
const paramCodeData = ref<{
  ofbu_source_channel: ParamCodeItem[]
}>({
  ofbu_source_channel: [] // 客户来源
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_source_channel']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
const marketOptions = ref<any[]>([])
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
onMounted(() => {
  getByParamCodes()
  getMarketOption()
})
// 获取办公地省市区数据
const customerAreaEnum = ref<any[]>([])
const getAdminArea = () => {
  const params = { appId: 'cos_ofbu' }
  adminArea(params).then((res) => {
    customerAreaEnum.value = res.data
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
onMounted(() => {
  getAdminArea()
})

const tableRef = ref()
const queryForm = reactive<SalesClueParams>({ contact: { type: 1 }, channelList: route.query.channelId ? [Number(route.query.channelId)] : [], channelExplain: route.query.channelExplain || '' })
const columns = computed(() => [
  {
    title: t('clue.customerName'),
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: t('clue.clueId'), dataIndex: 'clueId', width: 200 },
  { title: t('clue.clueChannel'), dataIndex: 'channel', width: 150 },
  { title: t('clue.clueType'), dataIndex: 'clueType', dicData: clueTypeEnum },
  { title: t('clue.clueStatus'), dataIndex: 'clueStatus' },
  { title: t('clue.customerRegion'), dataIndex: 'customerRegion' },
  { title: t('clue.followerName'), dataIndex: 'followerName' },
  { title: t('clue.beforeFollowerName'), dataIndex: 'beforeFollowerName' },
  { title: t('clue.notFollowDayNum'), dataIndex: 'notFollowDayNum' },
  { title: t('clue.customerOffice'), dataIndex: 'customerOffice' },
  { title: t('clue.marketActivity'), dataIndex: 'activityQrcodeId', dicData: marketOptions.value },
  { title: t('clue.followDesc'), dataIndex: 'followDesc' },
  { title: t('common.contactName'), dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: t('common.skype'), dataIndex: ['contact', 'skype'], cosType: 'mask' },
  { title: t('common.email'), dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: t('common.sex'), dataIndex: ['contact', 'sex'], dicData: genderEnum },
  { title: t('common.jobRole'), dataIndex: ['contact', 'jobRole'], dicData: linkRoleTypeEnum },
  { title: t('common.jobDuty'), dataIndex: ['contact', 'jobDuty'] },
  { title: t('common.createTime'), dataIndex: 'createTime', width: 190 },
  { title: t('clue.firstReceiveTime'), dataIndex: 'firstReceiveTime', width: 190 },
  { title: t('clue.lastReceiveTime'), dataIndex: 'lastReceiveTime', width: 190 },
  { title: t('custom.stageChangeTime'), dataIndex: 'stageChangeTime', width: 190 },
  { title: t('common.remark'), dataIndex: 'remark' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 360,
      en: 380
    },
    fixed: 'right'
  }
])
const getList = (queryForm: SalesClueParams, callBack: (res: any) => void) => {
  const params = cloneDeep(queryForm)
  const clueIds = params.clueId?.split(/[,，\s\n]/).filter((e: string) => e)
  if (clueIds && clueIds.length > 1) {
    params.clueIdList = clueIds
    delete params.clueId
  }
  salesClueList(params).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}

const selectedData = ref<SalesClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: SalesClueListItem[]) => {
  selectedData.value = selectedRows
}

// 退回线索
const handleSendBack = () => {
  if (selectedData.value.length === 0) return message.warning(t('tips.XviYDSD'))
  const params = {
    clueIdList: selectedData.value.map((item: SalesClueListItem) => item.clueId)
  }
  salesClueRefund(params).then(() => {
    message.success(t('tips.returnSuccess'))
    handleQueryChange('fetch')
  })
}

// 申请转有效线索
const becomeValidRef = ref()
const handleBecomeValid = () => {
  if (!selectedData.value.length) return message.warning(t('tips.lqxmibH4lN'))
  const hasValid = selectedData.value.some((item: SalesClueListItem) => item.clueType !== 3)
  if (hasValid) return message.warning(t('tips.WdKeuH'))
  becomeValidRef.value?.init(toRaw(selectedData.value))
}

// 置为无效线索
const becomeInvalidRef = ref()
const handleBecomeInvalid = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning(t('tips.He2i7afS9'))
  const paramsRow = row ? [row] : toRaw(selectedData.value)
  becomeInvalidRef.value?.init(paramsRow)
}

// 新增编辑函数
const triggerAddOrEdit = (clueId?: string, isPerfect?: string) => {
  if (clueId) {
    router.push({ path: '/ofbu/salesClue/edit', query: { clueId, isPerfect } })
  } else {
    router.push('/ofbu/salesClue/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (clueId: string) => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: clueId, returnPath: route.fullPath }
  })
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  if (!selectedData.value.length) return message.warning(t('tips.WJ6P9i7'))
  clueAssignRef.value?.init(toRaw(selectedData.value))
}

// 合并线索
const clueMargeRef = ref()
const handleClueMarge = () => {
  if (selectedData.value.length < 2) return message.warning(t('tips.VLM7eZ0'))
  clueMargeRef.value?.init(toRaw(selectedData.value))
}

// 新客评审
const handleNewClientEvaluation = (row?: SalesClueListItem, toPotential = true) => {
  if (!row) return
  if (row.clueType === 3) return message.warning(t('tips.newClientEvaTips'))
  router.push({ path: '/ofbu/newClientEvaluation/add', query: { clueId: row.clueId, toPotential: toPotential ? '1' : undefined } })
}
const handleDelete = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error(t('tips.MJY7jfnR'))
  }
  const clueIdList: any[] = []
  const customerName = []
  if (row) {
    clueIdList.push(row.clueId)
    customerName.push(row.customerName)
  } else {
    selectedData.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      customerName.push(item.customerName)
    })
  }
  const customerNameTxt = customerName.join(',')
  Modal.delete({
    content: t('custom.CUn3xat3', { customerName: customerNameTxt }),
    onOk() {
      salesClueDelete({ clueIdList }).then(() => {
        message.success(t('tips.delCluetSuccess'))
        deleteRefresh(0)
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosCascader = _resolveComponent("CosCascader")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              rowKey: "clueId",
              "row-selection": { onChange: onSelectRowsChange },
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[26] || (_cache[26] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              onMask: showMask,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosOFbuSalesClue"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.clueStatus')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: queryForm.clueStatus,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.clueStatus) = $event)),
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange('search')))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clueStatusEnum), (item) => {
                              return (_openBlock(), _createBlock(_component_a_radio_button, {
                                key: item.value,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)(item.lang)), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.clueType')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosSelect, {
                          value: queryForm.clueTypeList,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.clueTypeList) = $event)),
                          options: clueTypeEnumComputed.value,
                          placeholder: _unref(t)('common.pleaseSelect'),
                          allowClear: "",
                          mode: "multiple",
                          "max-tag-count": "responsive",
                          "show-arrow": ""
                        }, null, 8, ["value", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.notFollowDayNum')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosSelect, {
                          value: queryForm.notFollowDayNumType,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.notFollowDayNumType) = $event)),
                          options: _unref(customerUnfollowDayTypeEnum),
                          placeholder: _unref(t)('common.pleaseSelect'),
                          allowClear: ""
                        }, null, 8, ["value", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('common.createTime')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosRangePicker, {
                          isOutputBeijingTime: "",
                          startTime: queryForm.startCreateTime,
                          "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.startCreateTime) = $event)),
                          endTime: queryForm.endCreateTime,
                          "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.endCreateTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.customerName')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.customerName,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.customerName) = $event)),
                          maxlength: 100,
                          allowClear: "",
                          placeholder: _unref(t)('common.pleaseInput')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('common.contactMethod')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.contact.type,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.contact.type) = $event)),
                              style: {"width":"33%"},
                              placeholder: _unref(t)('common.pleaseSelect')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.mobile')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.email')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.skype')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.contact.keyword,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: _unref(t)('common.pleaseInput'),
                              allowClear: ""
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.followerName')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          value: queryForm.followerList,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.followerList) = $event)),
                          placeholder: _unref(t)('common.pleaseSelect'),
                          allowClear: "",
                          mode: "multiple"
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.clueId')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.clueId,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.clueId) = $event)),
                          maxlength: 100,
                          allowClear: "",
                          placeholder: _unref(t)('common.pleaseInput')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.receiveTime')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosRangePicker, {
                          isOutputBeijingTime: "",
                          startTime: queryForm.startReceiveTime,
                          "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.startReceiveTime) = $event)),
                          endTime: queryForm.endReceiveTime,
                          "onUpdate:endTime": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.endReceiveTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.channel')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ParamCodeCascader, {
                              type: "search",
                              ids: queryForm.channelList,
                              "onUpdate:ids": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.channelList) = $event)),
                              appId: "cos_ofbu",
                              paramCode: "ofbu_source_channel",
                              style: {"width":"33%"}
                            }, null, 8, ["ids"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.channelExplain,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.channelExplain) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: _unref(t)('common.pleaseInput'),
                              allowClear: ""
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.customerRegion')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_ofbu",
                          ids: queryForm.customerRegionList,
                          "onUpdate:ids": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.customerRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.customerOffice')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosCascader, {
                          value: queryForm.customerOffice,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.customerOffice) = $event)),
                          options: customerAreaEnum.value,
                          fieldNames: { label: 'name', value: 'id', children: 'children' },
                          placeholder: _unref(t)('common.pleaseSelect'),
                          "change-on-select": "",
                          allowClear: ""
                        }, null, 8, ["value", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      name: "activityQrcodeId",
                      label: _unref(t)('clue.marketActivity')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosSelect, {
                          value: queryForm.activityQrcodeId,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.activityQrcodeId) = $event)),
                          options: marketOptions.value,
                          placeholder: _unref(t)('common.pleaseSelect'),
                          allowClear: "",
                          optionFilterProp: "label",
                          showSearch: ""
                        }, null, 8, ["value", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (triggerAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_add_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (handleAssignPerson()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.personClue')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_person_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                  action: "/ofbu/api/clue/import",
                  templateUrl: "/ofbu/api/clue/template/download",
                  onSuccess: _cache[20] || (_cache[20] = ($event: any) => (handleQueryChange('search')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.import')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_import_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_ofbu",
                  taskType: "401",
                  search: queryForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'ofbu_clue_export_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (handleClueMarge()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.merge')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_merge_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (handleSendBack()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.returnBack')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_back_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (handleBecomeValid()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.applyValid')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_valid_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (handleBecomeInvalid()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.invalidate')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_invalid_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  danger: "",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (handleDelete()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_clue_del_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'customerName')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (record.clueStatus !== 8 && record.hasFollow === false)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "New"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        class: "ant-table-cell-ellipsis",
                        to: `/ofbu/salesClue/view?clueId=${record.clueId}`,
                        title: text
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text || '--'), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'channel')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 1,
                      appId: "cos_ofbu",
                      paramCode: "ofbu_source_channel",
                      value: text,
                      desc: record.channelExplain
                    }, null, 8, ["value", "desc"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 2,
                      appId: "cos_ofbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'clueStatus')
                  ? (_openBlock(), _createBlock(_component_dc_status, {
                      key: 3,
                      enums: statusEnum.value,
                      value: text
                    }, null, 8, ["enums", "value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerOffice')
                  ? (_openBlock(), _createBlock(_unref(CustomerArea), {
                      key: 4,
                      type: "text",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'followDesc')
                  ? (_openBlock(), _createBlock(EditorTableText, {
                      key: 5,
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_MoreButton, { key: 6 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          disabled: record.clueStatus === 8 || record.oaAuditStatus === '20' || record.oaAuditStatus === '30',
                          onClick: ($event: any) => (handleNewClientEvaluation(record, false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.newClientEvaluation')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'ofbu_new_client_evaluation_add_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          disabled: record.clueStatus === 8 || record.oaAuditStatus === '20' || record.oaAuditStatus === '30',
                          onClick: ($event: any) => (handleNewClientEvaluation(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.toPotentialAccount')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'ofbu_to_potential_account_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleWriteFollowUp(record.clueId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.writeFollow')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'ofbu_clue_write_follow_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (triggerAddOrEdit(record.clueId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'ofbu_clue_edit_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          workCode: record.follower,
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleBecomeInvalid(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.invalidate')), 1)
                          ]),
                          _: 2
                        }, 1032, ["workCode", "disabled", "onClick"])), [
                          [_directive_permission, 'ofbu_clue_invalid_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleDelete(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'ofbu_clue_del_btn']
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BecomeValid, {
      ref_key: "becomeValidRef",
      ref: becomeValidRef,
      onFetch: _cache[27] || (_cache[27] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: _cache[28] || (_cache[28] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(ClueMarge, {
      ref_key: "clueMargeRef",
      ref: clueMargeRef,
      onFetch: _cache[29] || (_cache[29] = ($event: any) => (deleteRefresh(1)))
    }, null, 512),
    _createVNode(BecomeInvalid, {
      ref_key: "becomeInvalidRef",
      ref: becomeInvalidRef,
      onFetch: _cache[30] || (_cache[30] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})